(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('CampagnaStatus', CampagnaStatus);

    CampagnaStatus.$inject = ['$resource'];

    function CampagnaStatus ($resource) {
        var resourceUrl =  'api/campagna-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
